import useFetchHelpCenter from 'app/hooks/fetch/useFetchHelpCenter';
import useHalfOpenEnabled from 'app/hooks/useHalfOpenEnabled';
import useIsMobile from 'app/hooks/useIsMobile';
import useShouldAutoOpen from 'app/modules/tailor/hooks/useShouldAutoOpen';
import { useEffect } from 'react';
import { useTailorHalfOpen } from 'app/hooks/useTailorHalfOpen';
import { useTailorHasOpened } from 'app/hooks/useTailorHasOpened';
import { useTailorIsOpen } from 'app/hooks/useTailorIsOpen';
import useAutoOpenEnabled from 'app/hooks/useAutoOpenEnabled';

import { useSuggestedArticle } from '../SuggestedArticleProvider';
import useManuallyClosed from './useManuallyClosed';

export default function useAutoOpenEffect() {
  const { setIsOpen } = useTailorIsOpen();
  const { setHasOpened } = useTailorHasOpened();
  const { setHalfOpen } = useTailorHalfOpen();
  const autoOpen = useAutoOpenEnabled();

  const { lastViewedArticle } = useSuggestedArticle();
  const halfOpenEnabled = useHalfOpenEnabled();
  const [shouldAutoOpen, , removeShouldAutoOpen] = useShouldAutoOpen();
  const [isManuallyClosed] = useManuallyClosed();
  const isMobile = useIsMobile();
  const { data: helpCenterData } = useFetchHelpCenter();

  const queryParams = new URLSearchParams(window.location.search);
  const qsAutoOpenDelay = queryParams.get('ostroAutoOpenDelay');
  const qsEngageHubOpen = queryParams.get('engagehubopen');
  const forceOpen = qsEngageHubOpen?.toLowerCase() === 'true';

  const autoOpenDelay =
    qsAutoOpenDelay !== null
      ? parseInt(qsAutoOpenDelay, 10)
      : helpCenterData?.options?.[isMobile ? 'autoopen_mobile_delay_ms' : 'autoopen_desktop_delay_ms'] ?? 0;

  useEffect(() => {
    if (shouldAutoOpen === false && !forceOpen) {
      setIsOpen(false);
      removeShouldAutoOpen();
    } else if (forceOpen || ((shouldAutoOpen === true || autoOpen) && !isManuallyClosed)) {
      if (lastViewedArticle) {
        setIsOpen(false);
      } else {
        const timeout = setTimeout(() => {
          setIsOpen(true);
          setHasOpened(true);
          removeShouldAutoOpen();
          if (halfOpenEnabled) {
            setHalfOpen(true);
          }
        }, autoOpenDelay);
        return () => clearTimeout(timeout);
      }
    }
  }, [autoOpen]); // eslint-disable-line react-hooks/exhaustive-deps
}
